// components/ui/ClickableCard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const INTERACTIVE_SELECTOR =
  'button, a, input, select, textarea, [role="button"], [role="link"], [contenteditable="true"], [data-interactive="true"]';

export default function ClickableCard({
  to,
  children,
  className = "",
  ariaLabel,
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (e.defaultPrevented) return;

    const match = e.target.closest?.(INTERACTIVE_SELECTOR);
    // If the match exists and it's NOT the wrapper itself, ignore (let inner control handle it)
    if (match && match !== e.currentTarget) return;

    navigate(to);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      // Only trigger when the wrapper itself is focused
      if (e.currentTarget === document.activeElement) {
        e.preventDefault();
        navigate(to);
      }
    }
  };

  return (
    <div
      role="link"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`cursor-pointer focus:outline-none ${className}`}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}
